import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_SGTEC_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterEtapas() {
        return axiosJwt
            .get(`${api}/sgtec/gestores/etapas`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },
    obterEtapasFaturadasNaoQuitadas() {
        return axiosJwt
            .get(`${api}/sgtec/gestores/etapas/EtapasFaturadasNaoQuitadas`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },
    obterEtapasPorVencimentos() {
        return axiosJwt
            .get(`${api}/sgtec/gestores/etapas/vencimentos`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterProjeto(projetoId) {
        return axiosJwt
            .get(`${api}/sgtec/gestores/projetos/${projetoId}`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterDespesas(etapaId) {
        return axiosJwt
            .get(`${api}/sgtec/gestores/etapas/${etapaId}/despesas`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterErroComprometimento(etapaId, despesaId) {
        return axiosJwt
            .get(`${api}/sgtec/gestores/etapas/${etapaId}/despesas/${despesaId}/errocomprometimento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    alterarNaoAditivar(etapaId) {
        return axiosJwt
            .patch(`${api}/sgtec/gestores/etapas/${etapaId}/naoaditivar`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
